import React, {FC} from "react";

import InfoIcon from '@mui/icons-material/Info';

import "./EmailHeaderStatusBar.scss";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {Button} from "@mui/material";
import {FlexSpacerDiv} from "../panels/FlexSpacerDiv";
import {EmailActions} from "../../actions/EmailActions";

export const EmailHeaderStatusBar: FC = () => {

    const selectionCount = useAppSelector(s => s.itemState.selectedEmailHeaders.length);

    const dispatch = useAppDispatch();

    if (selectionCount <= 1) {
        return null;
    }

    function onClearSelection() {
        dispatch(EmailActions.selectEmailHeaders([]));
    }

    return (
        <div className="email-header-status-bar">
            <Button color="primary"
                    sx={{float: "right", maxHeight: "28px", marginTop: "-1px"}}
                    variant="contained"
                    onClick={() => onClearSelection()}>
                Clear
            </Button>

            <FlexSpacerDiv/>

            <InfoIcon/>
            <span>{selectionCount} emails selected</span>

            <FlexSpacerDiv/>
        </div>
    );
};
